import { HTTP } from '@/utils/http';
import * as actions from '../types/actions';
import * as getters from '../types/getters';
import * as mutations from '../types/mutations';

export default {
  actions: {
    async [actions.DO_CREATE_MINISTRY_ROLE]({ commit }, payload) {
      const { data } = await HTTP.post('/ministry_roles', payload);
      commit(mutations.SET_MINISTRY_ROLE, data.data.ministry_roles[0]);
      return data;
    },
    async [actions.DO_DELETE_MINISTRY_ROLE]({ commit }, payload) {
      const { id, ...params } = payload;
      const { data } = await HTTP.delete(`/ministry_roles/${id}`, params);
      commit(mutations.SET_MINISTRY_ROLE, data.data.ministry_roles[0]);
      return data;
    },
    async [actions.DO_UPDATE_MINISTRY_ROLE]({ commit }, payload) {
      const { id, ...params } = payload;
      const { data } = await HTTP.patch(`/ministry_roles/${id}`, params);
      commit(mutations.SET_MINISTRY_ROLE, data.data.ministry_roles[0]);
      return data;
    },
  },
  getters: {
    [getters.GET_MINISTRY_ROLE]: state => state.role,
  },
  mutations: {
    [mutations.SET_MINISTRY_ROLE](state, role) {
      state.role = role;
    },
  },
  state: {
    role: {},
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/ministry_role.js